import registerRootComponent from 'expo/build/launch/registerRootComponent'

import App from './App'

registerRootComponent(App)
